/**
 * Local JWT decode helpers for fast auth bootstrap.
 * Signature is not verified client-side — same trust model as route-protection.
 */

import type { JwtPayload } from "../api/types";

/** Decode a JWT payload without network verify. Returns null if invalid/expired. */
export function decodeAccessTokenPayload(
  token: string | null | undefined,
): JwtPayload | null {
  if (!token) return null;
  try {
    const part = token.split(".")[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, "+").replace(/_/g, "/"));
    const payload = JSON.parse(json) as JwtPayload;
    if (typeof payload.exp === "number" && payload.exp * 1000 <= Date.now()) {
      return null;
    }
    if (!payload.sub || !Array.isArray(payload.roles)) {
      return null;
    }
    return payload;
  } catch {
    return null;
  }
}
